import React from 'react';
import './Footer.css';

const quickLinks = ['Home', 'About', 'Courses', 'Features', 'Contact'];
const courseLinks = ['Mathematics', 'Science', 'English', 'Social Science (SST)', 'Computers', 'Hindi', 'Sanskrit'];

export default function Footer() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__grid">
          <div className="footer__brand">
            <div className="footer__logo">🎓 Triumph Classes</div>
            <p className="footer__desc">
              Empowering students since 2009 with quality education, expert faculty, and a proven track record of academic success.
            </p>
            <div className="footer__social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer__social-link">📘</a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="footer__social-link">📷</a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="footer__social-link">▶️</a>
            </div>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Quick Links</h4>
            <ul className="footer__links">
              {quickLinks.map((link) => (
                <li key={link}>
                  <button
                    className="footer__link"
                    onClick={() => scrollTo(link.toLowerCase())}
                  >
                    → {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Our Courses</h4>
            <ul className="footer__links">
              {courseLinks.map((c) => (
                <li key={c}>
                  <button className="footer__link" onClick={() => scrollTo('courses')}>
                    → {c}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Contact Us</h4>
            <div className="footer__contact-list">
              <p>📍 2nd A - 23, Nehru Nagar II, Nehru Nagar, Ghaziabad, UP 201001</p>
              <p>📞 +91 88004 69527</p>
              <p>🕐 Open 24 Hours</p>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} Triumph Classes. All rights reserved.</p>
          <p>Made with ❤️ for students across India</p>
        </div>
      </div>
    </footer>
  );
}
